import AwardSmallIcon from '@hapana/shared/web/styles/assets/svgs/award-small.svg'
import CrownSmallIcon from '@hapana/shared/web/styles/assets/svgs/crown-small.svg'
import DiamondSmallIcon from '@hapana/shared/web/styles/assets/svgs/diamond-small.svg'
import ShieldSmallIcon from '@hapana/shared/web/styles/assets/svgs/shield-small.svg'

export const EQUIPMENT_CATEGORIES = {
  UV: 'UV',
  REGULAR: 'regular',
}

export const EQUIPMENT_WARNINGS_CATEGORIES = {
  WARN: 'warn',
  STOP: 'stop',
}

export const EQUIPMENT_STATUSES = {
  SELECTED: 'selected',
  AVAILABLE: 'available',
  DELAY: 'delay',
  IN_USE: 'in_use',
  DIRTY: 'dirty',
  ERROR: 'error',
  DISABLED: 'disabled',
}

export const EQUIPMENT_ASSIGNMENT_STATUSES = {
  CREATED: 'created',
  DONE: 'done',
  CANCELLED: 'cancelled',
}

export const EQUIPMENT_QUALITY_CATEGORIES_MAP = {
  silver: {
    label: 'equipments.assignToEquipment.silver',
    value: 'silver',
    icon: AwardSmallIcon,
  },
  gold: {
    label: 'equipments.assignToEquipment.gold',
    value: 'gold',
    icon: CrownSmallIcon,
  },
  platinum: {
    label: 'equipments.assignToEquipment.platinum',
    value: 'platinum',
    icon: ShieldSmallIcon,
  },
  diamond: {
    label: 'equipments.assignToEquipment.diamond',
    value: 'diamond',
    icon: DiamondSmallIcon,
  },
}
